export default "__VITE_ASSET__8ff4ee2d__"